module.exports = __webpack_public_path__ + "img/company_famous.dc723f60.png";